import { create } from "zustand";
import type { SpeechStore } from "../types";
import { fetchVoices } from "../../api/";


export const useSpeechStore = create<SpeechStore>((set, get) => ({
    audio: null,
    instanceIds: [],
    resetIDs: () => set({ instanceIds: [] }),
    setInstanceIds: (ids: string[]) => set({ instanceIds: ids }),
    voices: [],
    setAudio: (audio: HTMLAudioElement | null) => set({ audio }),
    stopAudio: () => {
        const audio = get().audio;
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
            set({ audio: null });
        }
    },
    setVoices: async () => {
        set({ voices: await fetchVoices() });
    }
}));
